// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <input data-hello-target="name" type="text">
//   <button data-action="click->hello#greet">Greet</button>
// </div>
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "email" ]

  connect () {
    this.emailTarget.focus()

    super.connect()
  }

}
